module.exports = __webpack_public_path__ + "static/media/013_intel3_1.f8b3138f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/013_intel3_1.png
// module id = 483
// module chunks = 0